import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import UserServices from "../services/UserServices";
import FormServices from "../services/FormServices";
import StateServices from "../services/StateServices";
// import "./Header/Css/form.css";
import "./Button/Css/form.css"
import ukimage from "./Header/Img/ukPolice.png";
function UserForm({ closeModal }) {
    const { encodedId } = useParams(); // Get encoded ID from URL
    const [user, setUser] = useState(null);
    const [form, setForm] = useState(null);
    const decodedId = atob(encodedId); // Decode Base64 ID
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [thanaEmail, setThanaEmail] = useState("");
    const [hasCriminalRecord, setHasCriminalRecord] = useState(null); // State for criminal record
    const [firs, setFirs] = useState([{ id: 1, value: "" }]); // Manage FIR inputs
    const [formValues, setFormValues] = useState({
        profile: decodedId,
        criminalRecord: "",
        fir: [],
        mobileNo: "",
        officerName: "",
        officerMobileNo: "",
        designation: "",
    });
    const [isFormFilled, setIsFormFilled] = useState(false); // Track if form is filled

    // Fetch user data on component mount
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await UserServices.getsingleData(decodedId);
                setUser(response.data);
            } catch (err) {
                setError("Failed to fetch user data.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchUserData();
    }, [decodedId]);
    console.log("user", user)
    // Fetch form data and check if it's filled
    useEffect(() => {
        const fetchFormData = async () => {
            try {
                const response = await FormServices.getSingleFormData(decodedId);
                setForm(response.data);

                // If form data is present, populate form fields and set filled state
                if (response.data) {
                    const firData = response.data.fir.map((fir, index) => ({
                        id: index + 1,
                        value: fir,
                    }));

                    setFormValues({
                        profile: response.data.profile || decodedId,
                        criminalRecord: response.data.criminalRecord || "",
                        officerName: response.data.officerName || "",
                        officerMobileNo: response.data.officerMobileNo || "",
                        designation: response.data.designation || "",
                    });

                    setFirs(firData.length > 0 ? firData : [{ id: 1, value: "" }]);
                    setHasCriminalRecord(response.data.criminalRecord === "Yes");
                    setIsFormFilled(true); // Mark form as filled
                }
            } catch (err) {
                setError("Failed to fetch form data.");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchFormData();
    }, [decodedId]);

    const handleAddFIR = () => {
        setFirs([...firs, { id: firs.length + 1, value: "" }]);
    };

    const handleFIRChange = (id, value) => {
        setFirs(firs.map((fir) => (fir.id === id ? { ...fir, value } : fir)));
    };

    const handleRemoveFIR = (id) => {
        setFirs(firs.filter((fir) => fir.id !== id));
    };

    const printButtonStyle = {
        marginLeft: "325px",
        marginBottom: "10px",
        padding: "10px 20px",
        cursor: "pointer",
        backgroundColor: "#223973",
        color: "#fff",
        textAlign: "center"
    };
    const handlePrint = () => {
        window.print();
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const firNumbers = firs.map((fir) => fir.value); // Collect all FIR numbers
            const finalFormValues = {
                ...formValues,
                criminalRecord: hasCriminalRecord ? "Yes" : "No",
                fir: hasCriminalRecord ? firNumbers : [],
            };

            await FormServices.createForm(finalFormValues);
            alert("Form submitted successfully!");
        } catch (error) {
            console.error("Failed to submit the form", error);
            alert("Failed to submit the form.");
        }
    };

    const currentDate = new Date();
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const day = String(currentDate.getDate()).padStart(2, '0');
    const monthName = months[currentDate.getMonth()];
    const year = currentDate.getFullYear();

    const formattedDate1 = `${day}-${monthName}-${year}`;

    // Format the date as dd-mm-yyyy
    const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
    const VerifyformatDate = (isoDateStr) => {
        const date = new Date(isoDateStr);

        const day = String(date.getDate()).padStart(2, '0');
        const monthName = date.toLocaleString('en-US', { month: 'long' });
        const year = date.getFullYear();

        return `${day}-${monthName}-${year}`;
    };
    const districtName = localStorage.getItem("district");
    const policeStationName = localStorage.getItem("policeStation");
    const roleLabelMap = {
        Admin: "Nodal Officer",
        User: "P.S. Head",
        CO: "Circle Head",
      };
      
      const userRole = localStorage.getItem("userRole");

    // Fetch thana email using police station name (from Thana table)
    useEffect(() => {
        const fetchThanaEmail = async () => {
            const name = policeStationName || user?.presentAddress?.policeStation?.name || user?.permanentAddress?.policeStation?.name;
            if (!name) return;
            try {
                const res = await StateServices.getThanaEmailByName(name);
                setThanaEmail(res?.data?.email || "");
            } catch (err) {
                console.error("Failed to fetch thana email", err);
                setThanaEmail("");
            }
        };
        fetchThanaEmail();
    }, [policeStationName, user]);

    return (
        
        <div className="certificate-container">
            <div className="certificate-header">
                <img
                    src={ukimage}
                    alt="Police Logo"
                    className="logo"
                />
                <div className="header-text">
                    <div className="header-title">Uttarakhand Police, District {districtName}</div>
                    {/* <div className="header-contact">Phone No. 05946-231534, E-mail- add-sphld@uttarakhandpolice.uk.gov.in</div> */}
                    <div className="header-contact">E-mail- {thanaEmail || 'add-sphld@uttarakhandpolice.uk.gov.in'}</div>
                    <h3 className="verification-report"><strong>(Verification Report)</strong></h3>
                </div>
            </div>
            <div className="profile-section">
                <div className="profile-photo-block">
                    <img
                        src={user?.image ? `${process.env.REACT_APP_URL}${user?.image}` : "img/profile-img.png"}
                        alt="Applicant Photo"
                        className="profile-photo"
                    />
                </div>
                <div className="profile-details">
                    <div className=""><strong>Issue Date :</strong>&nbsp;<span>{formattedDate1}</span></div>
                    <div className="detail-row">
                        <div>
                            <span className="detail-label">Name:</span>&nbsp;&nbsp;&nbsp;&nbsp;
                            <span className="detail-value">{user?.name}</span>
                        </div>
                        <div>
	                    <span className="detail-label">Father's Name:</span>&nbsp;&nbsp;&nbsp;&nbsp;
                            <span className="detail-value">{user?.fathersName}</span>
                        </div>
                    </div>
                    <div className="detail-row">
                        <div>
                            <span className="detail-label">Verification ID:</span>
                            <span className="detail-value">{user?.verificationId}</span>
                        </div>
                        
                    </div>
                    <div className="detail-row">
                        <div>
                            <span className="detail-label">Age:</span>
                            <span className="detail-value">{user?.age}</span>
                        </div>
                        <div>
                            <span className="detail-label">Gender:</span>
                            <span className="detail-value">{user?.gender}</span>
                        </div>
                    </div>
                    <div className="detail-row">
                        <div>
                            <span className="detail-label">Aadhar No:</span>
                            <span className="detail-value">{user?.aadharNo}</span>
                        </div>
                        <div>
                            <span className="detail-label">Mobile No:</span>
                            <span className="detail-value">{user?.mobileNo}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="address-section">
                <div className="address-title">Address Information</div>
                <table className="address-table">
                    <tbody>
                        <tr style={{ marginBottom: '16px', display: 'table-row' }}>
                            <th>Permanent Address</th>
                            <td>
                                {user?.permanentAddress?.mohalla} Ward No: {user?.permanentAddress?.ward || 'N/A'} Police Station: {user?.permanentAddress?.policeStation?.name}
                                <br />
                                District: {user?.permanentAddress?.district?.name}, State: {user?.permanentAddress?.state?.name}, Pincode:{user?.permanentAddress?.pinCode}
                            </td>
                        </tr>
                        <tr>
                            <th>Present Address</th>
                            <td>
                                {user?.presentAddress?.mohalla} Ward No: {user?.presentAddress?.ward || 'N/A'} Police Station: {user?.presentAddress?.policeStation?.name}
                                <br />
                                District: {user?.presentAddress?.district?.name}, State: {user?.presentAddress?.state?.name}, Pincode:{user?.presentAddress?.pinCode}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <form onSubmit={handleSubmit}>
                <h4 style={{   marginTop: "-16px",marginLeft: "26px" }}>Does the above person have any criminal record?</h4>
                <div style={{ marginLeft: "26px", marginTop: "-16px"}}>
                    <label>
                        <input
                            type="radio"
                            name="criminalRecord"
                            value={formValues.criminalRecord}
                            checked={hasCriminalRecord === true}
                            onChange={() => setHasCriminalRecord(true)}
                            disabled={isFormFilled}
                        />
                        Yes
                    </label>
                    <label style={{ marginLeft: "20px" }}>
                        <input
                            required
                            type="radio"
                            name="criminalRecord"
                            value={formValues.criminalRecord}
                            checked={hasCriminalRecord === false}
                            onChange={() => setHasCriminalRecord(false)}
                            disabled={isFormFilled}
                        />
                        No
                    </label>
                </div>

                {hasCriminalRecord === true && (
                    <div style={{ marginTop: "-16px", marginLeft: "26px" }}>
                        <br />
                        <h4>FIR No, U/S , Date/Year, Police Station, CS/FR
                            *</h4>
                        {firs.map((fir) => (
                            <div
                                key={fir.id}
                                style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}
                            >
                                {isFormFilled ? (
                                    <span style={{ padding: "5px", width: "80%", backgroundColor: "#fff", borderRadius: "4px", marginTop:"-20px" }}>
                                        {fir.value}
                                    </span>
                                ) : (
                                    <input
                                        type="text"
                                        required
                                        value={fir.value}
                                        onChange={(e) => handleFIRChange(fir.id, e.target.value)}
                                        placeholder="Your Answer"
                                        style={{ marginRight: "10px", padding: "5px", width: "80%" }}
                                        disabled={isFormFilled}
                                    />
                                )}

                                {firs.length > 1 && !isFormFilled && (
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveFIR(fir.id)}
                                        style={{
                                            padding: "5px",
                                            cursor: "pointer",
                                            backgroundColor: "#dc3545",
                                            color: "#fff",
                                        }}
                                    >
                                        Remove
                                    </button>
                                )}
                            </div>
                        ))}

                        {!isFormFilled && (
                            <button
                                type="button"
                                onClick={handleAddFIR}
                                className="submit-green-btn"
                                style={{ marginTop: "10px", padding: "5px 10px", cursor: "pointer", backgroundColor: "#223973", color: "#fff" }}
                            >
                                Add More FIR
                            </button>
                        )}
                    </div>
                )}

                {hasCriminalRecord !== null && (
                    <div style={{ marginTop: "-10px", marginLeft: "26px" }}>
			<h4>Above details verified by:</h4>

                        {isFormFilled ? (
                            <>
                                <p className="officer-detials" style={{ marginTop: "-16px"}}>Officer Name: {formValues.officerName}</p>
                                <p className="officer-detials">Designation: {formValues.designation}</p>
                                {/* <p className="officer-detials print-button">Officer Mobile No.: {formValues.officerMobileNo}</p> */}
                                <p className="officer-detials">Thana/District: {user?.permanentAddress?.policeStation?.name}/{user?.permanentAddress?.district?.name}</p>
                                <p className="officer-detials">State: {user?.permanentAddress?.state?.name}</p>

                            </>
                        ) : (
                            <>
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
                                    <div style={{ width: "48%" }}>
                                        <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
                                            Officer Name
                                        </label>
                                        <input
                                            type="text"
                                            name="officerName"
                                            value={formValues.officerName}
                                            onChange={handleInputChange}
                                            placeholder="Enter officer name"
                                            required
                                            style={{
                                                padding: "8px",
                                                width: "100%",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                        />
                                    </div>

                                    <div style={{ width: "48%" }}>
                                        <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
                                            Officer Mobile No.
                                        </label>
                                        <input
                                            type="text"
                                            maxLength={10}
                                            name="officerMobileNo"
                                            value={formValues.officerMobileNo}
                                            onChange={handleInputChange}
                                            placeholder="Enter officer mobile number"
                                            style={{
                                                padding: "8px",
                                                width: "100%",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                            }}
                                            required
                                        />
                                    </div>
                                </div>

                                <div style={{ marginBottom: "15px" }}>
                                    <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>
                                        Designation
                                    </label>
                                    <select
                                        name="designation"
                                        value={formValues.designation}
                                        onChange={handleInputChange}
                                        required
                                        style={{
                                            padding: "8px",
                                            width: "100%",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                        }}
                                    >
                                        <option value="">Choose</option>
                                        <option value="SSP">SSP</option>
                                        <option value="SP">SP</option>
                                        <option value="Dy. SP">Dy. SP</option>
                                        <option value="Inspector">Inspector</option>
                                        <option value="Sub Inspector">Sub Inspector</option>
                                        <option value="Add. Sub Inspector">Add. Sub Inspector</option>
                                        <option value="Head Constable">Head Constable</option>
                                        <option value="Constable">Constable</option>
                                    </select>
                                </div>
                            </>
                        )}
                    </div>
                )}


                {!isFormFilled && (
                    <div style={{ marginTop: "20px", display: "flex", textAlign: "center", marginLeft: "26px", justifyContent: "flex-end" }}>
                        <button type="submit" style={{ padding: "10px 20px", cursor: "pointer", backgroundColor: "#223973", color: "#fff" }}>
                            Submit
                        </button>
                    </div>
                )}
            </form>
            {form && form.criminalRecord === "No" && (
                <div className="footer">Has no Criminal record.</div>
            )}
            {isFormFilled && (
                <div className="footer-right" style={{ marginBottom: 0, paddingBottom: 0 }}>
                    <p>Digitally Signed </p>
                    {/* <p>S.P City: Haldwani</p> */}
                    <p>{roleLabelMap[userRole]}: {policeStationName}</p>
                    <p>District:&nbsp;&nbsp;{districtName}</p>
                </div>
            )}
            
            {isFormFilled && (
                <div className="footer-text" style={{ marginTop: 0, paddingTop: 0 }}>
		This certificate is digitally signed and is valid for one Year. Verified as per Police records.
		</div>
            )}


            <style>
                {`
          @media print {
            .print-button {
              display: none !important;
            }
          }
        `}
            </style>

            <button
                onClick={handlePrint}
                className="print-button"
                style={printButtonStyle}
            >
                Print
            </button>
        </div>
        

    );
}

export default UserForm;

